module.exports = __webpack_public_path__ + "static/media/avatar-sign.0a1a09e2.png";